import http from "e6-base-core/axios/config";
/************************电子路书******************************* */
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";

const {
  host = "",
  E6_MS_TMS_BASE_WEB = "",
  E6_MS_TMS_PERSONALIZE_WEB = "",
  E6_MS_TMS_E6YUN_BASE_WEB = ""
} = e6ModuleOrderWaybillProcessApi;
// 电子路书列表
export function fetchRoadBookTable(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/page`,
    method: "post",
    data
  });
}
// 删除电子路书
export function deleteRoadBooksInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/delete/batch`,
    method: "post",
    data
  });
}
export function getRoadBooksVehicleTree() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/getOrgVehicleTree`,
    method: "get"
  });
}
export function getRoadBooksVehicleList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/findAllVehicles`,
    method: "post",
    data
  });
}
export function getRoadBooksDriverList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/findAllDriverByPage`,
    method: "post",
    data
  });
}
export function getRoadBooksAreaList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePositionNew`,
    method: "post",
    data
  });
}
export function getRoadBooksOrgList() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/findOrganizationTree`,
    method: "get"
  });
}
// 获取电子路书区域
export function findRoadBookAreaList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/findAreaList`,
    method: "post",
    data
  });
}
// 检查电子路书名称
export function checkRoadName(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/checkName`,
    method: "get",
    params
  });
}
// 获取电子路书类型
export function getFixedLineModeSet() {
  return http({
    url: `${host}${E6_MS_TMS_PERSONALIZE_WEB}/personalSet/getFixedLineModeSet`,
    method: "get"
  });
}
// 添加电子路书
export function addRoadBook(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/save`,
    method: "post",
    data
  });
}
// 修改电子路书
export function updateRoadBook(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/update`,
    method: "post",
    data
  });
}
// 电子路书更改记录
export function fetchRoadBookHistory(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/findFixedIdsHistoryByPage`,
    method: "post",
    data
  });
}
// 电子路书详情
export function getRoadBookDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/findFixedLineById`,
    method: "get",
    params
  });
}

// 导出电子路书
export function exportRoadBook(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/exportFixedLineInfo`,
    method: "post",
    data
  });
}
//历史记录中的电子路书详情
export function fetchRoadBookDetailByHistoryId(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/findFixedLineHistoryById`,
    method: "get",
    params
  });
}
// 智能排线
export function smartSortArea(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/fixedLineNavigation`,
    method: "post",
    data
  });
}
